import React, { useEffect } from 'react';
import { ArrowCircleRightIcon, ArrowCircleLeftIcon } from "@heroicons/react/outline";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from 'lodash';
import { changeUserAttribute } from "../../actions/auth";
import imageOnboardingAdminStep2 from "../../assets/images/onboarding-admin-step2.svg";
import imageOnboardingUserStep1 from "../../assets/images/onboarding-user-step1.svg";
import { ONBOARDING_STATE } from "../../constants/UserSettings";
import { isOnboarding, isUserAdmin } from "../../utils/userState";
import './InfoGraphics.scss';

const InfoGraphics = props => {
  const isAdmin = isUserAdmin(props.cognitoUser);


  useEffect(() => {
    const customState = _.get(props, "cognitoUser.attributes['custom:state']", null);
    const onboarding = isOnboarding(props.cognitoUser);

    if (customState && (!onboarding && customState !== 'invited')) {
      props.history.push('/dashboard')
    }
  }, []);

  const goBack = () => {
    props.changeUserAttribute({ name: 'state', value: ONBOARDING_STATE.INITIAL_STATE });
    props.history.push('/onboarding/survey');
  }

  const goNext = () => {
    props.changeUserAttribute({ name: 'state', value: 'onboarding-03' });
    props.history.push('/onboarding/checklist');
  }

  return (
    <div className="onboarding-infographics-container">
      <div className="arrow-box">
        {isAdmin && <ArrowCircleLeftIcon onClick={goBack} />}
      </div>
      <div className="content-view">
        <h1>{ isAdmin ? 'Just some of the things you can do with Content Camel:' : 'Hi! Here\'s what you can do with Content Camel:'}</h1>
        <img src={isAdmin ? imageOnboardingAdminStep2 : imageOnboardingUserStep1} alt="Organize, publish, share, report" />
      </div>
      <div className="arrow-box">
        <ArrowCircleRightIcon onClick={goNext} />
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  user: state.auth.tenant,
  cognitoUser: state.auth.cognitoUser
});

const mapDispatchToProps = dispatch => 
  bindActionCreators({
    changeUserAttribute
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(InfoGraphics);
